import { ErrorHandler } from '@angular/core';
import { Injectable } from '@angular/core';
import { StringConstants } from '../../constants/string-constants';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  handleError(error) {
    // Log out errors only in Local or Dev
    if (isLocalEnv() || isDevEnv()) {
      super.handleError(error);
    }
  }
}

const isLocalEnv = () => window.location.host.includes(StringConstants.LOCALHOST_ENV);
const isDevEnv = () => window.location.host.includes(StringConstants.DEV_ENV);
